const domain: string = "SNACKBAR";

export const DISPLAY_SNACKBAR: string = `${domain}/DISPLAY_SNACKBAR`;
export const HIDE_SNACKBAR: string = `${domain}/HIDE_SNACKBAR`;